<template>
  <div class="liu">
    <div class="retail-business-examine">
      <!-- title -->
      <mt-header fixed title="审核小微商户" class="title2 no-roll">
        <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
      </mt-header>
      <!-- 正文 -->
      <div class="scroll-container">
        <!-- 基本信息 -->
        <div class="examine-info">
          <div class="info-row">
            <span class="label">商户名称</span>
            <span class="text">{{ busInfo.userName }}</span>
          </div>
          <div class="info-row">
            <span class="label">手机号</span>
            <span class="text">{{ busInfo.userMobile }}</span>
          </div>
          <div class="info-row">
            <span class="label">商户简称</span>
            <span class="text">{{ busInfo.userShortName }}</span>
          </div>
          <div class="info-row">
            <span class="label">账户类型</span>
            <span class="text">{{ busInfo.account }}</span>
          </div>
          <div class="info-row" v-if="photoShowFlag">
            <span class="label">营业执照号</span>
            <span class="text">{{ busInfo.businessLicense }}</span>
          </div>
          <div class="info-row">
            <span class="label">从事行业</span>
            <span class="text">{{ busInfo.businessName }}</span>
          </div>
          <div class="info-row">
            <span class="label">所在地区</span>
            <span class="text">{{ busInfo.area }}</span>
          </div>
          <div class="info-row">
            <span class="label">详细地址</span>
            <span class="text">{{ busInfo.address }}</span>
          </div>
          <div class="info-row">
            <span class="label">商户入驻时间</span>
            <span class="text">{{ busInfo.insertDate }}</span>
          </div>
        </div>
        <!-- 照片 -->
        <div class="examine-info" v-if="photoShowFlag">
          <div class="photo-row" v-if="busInfo.licenseUrl">
            <div class="label">营业执照照片</div>
            <img :src="busInfo.licenseUrl || noImg" alt="" />
          </div>
          <div class="photo-row" v-if="busInfo.storeHeaderImgUrl">
            <div class="label">店铺门头照片</div>
            <img :src="busInfo.storeHeaderImgUrl || noImg" alt="" />
          </div>
          <div class="photo-row" v-if="busInfo.storeIndoorImgUrl">
            <div class="label">营业场所照片</div>
            <img :src="busInfo.storeIndoorImgUrl || noImg" alt="" />
          </div>
          <div class="photo-row" v-if="busInfo.storeCashierImgUrl">
            <div class="label">收银台照片</div>
            <img :src="busInfo.storeCashierImgUrl || noImg" alt="" />
          </div>
        </div>
        <!-- 审核意见 -->
        <div class="examine-info">
          <div class="input-row">
            <div class="label">审核意见</div>
            <input type="text" v-model="busInfo.auditContent" placeholder="请输入审核意见" />
          </div>
        </div>
        <!-- 按钮 -->
        <div class="btn-group">
          <mt-button class="btn" type="primary" @click="onNoBtnClick">
            拒绝
          </mt-button>
          <mt-button class="btn ml" type="primary" @click="onYesBtnClick">
            通过
          </mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetXWSHAuditDetail, AuditXWSH } from '@/api/manage';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';
import { Indicator } from 'mint-ui';

export default {
  name: 'RetailBusinessExamineEdit',
  data() {
    return {
      busInfo: {
        userName: '',
        userMobile: '',
        userShortName: '',
        account: '',
        businessLicense: '',
        businessName: '',
        area: '',
        address: '',
        insertDate: '',
        licenseUrl: '',
        storeHeaderImgUrl: '',
        storeIndoorImgUrl: '',
        storeCashierImgUrl: '',
        auditContent: '',
      },
      noImg: require('@/assets/risk_img_default@3x.png'),
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    photoShowFlag() {
      return this.busInfo.account === '标准商户';
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空

      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      GetXWSHAuditDetail({ id: this.$route.query.id })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.busInfo.userName = res.data.userName;
              this.busInfo.userMobile = res.data.userMobile;
              this.busInfo.userShortName = res.data.userShortName;
              this.busInfo.account = res.data.account;
              this.busInfo.businessLicense = res.data.businessLicense;
              this.busInfo.businessName = res.data.businessName;
              this.busInfo.area = res.data.area;
              this.busInfo.address = res.data.address;
              this.busInfo.insertDate = res.data.insertDate;
              this.busInfo.licenseUrl = res.data.licenseUrl;
              this.busInfo.storeHeaderImgUrl = res.data.storeHeaderImgUrl;
              this.busInfo.storeIndoorImgUrl = res.data.storeIndoorImgUrl;
              this.busInfo.storeCashierImgUrl = res.data.storeCashierImgUrl;
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 验证审核意见
    validateAuditContent() {
      if (!this.busInfo.auditContent) {
        CusToast('审核意见不能为空');
        return 'err';
      }
      return 'ok';
    },
    // 审核小微商户
    auditXWSH(auditStatus) {
      if (this.validateAuditContent() === 'err') return;
      Indicator.open();
      AuditXWSH({ auditContent: this.busInfo.auditContent, auditStatus: auditStatus, id: this.$route.query.id })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              res.msg && CusToast(res.msg);
              this.$router.go(-1);
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 审核拒绝按钮事件
    onNoBtnClick() {
      this.auditXWSH(-1);
    },
    // 审核通过按钮事件
    onYesBtnClick() {
      this.auditXWSH(1);
    },
  },
};
</script>
